import React from "react";
import '../css/navbar.css';

function Navbar() {
    
    const closeMenu = () => {
        document.querySelector('.mobile-links').classList.remove('show-links');
    };
    
    const toggleMenu = () => {
        document.querySelector('.mobile-links').classList.toggle('show-links');
    };

    return (
        <nav>
            <a href="#home"><img src={require('../img/logo.png')} alt="" /></a>
            <div className="nav-links">
                <a href="#home">HOME</a>
                <a href="#technologies">TECHNOLOGIES</a>
                <a href="#education">EDUCATION</a>
                <a href="#certificates">CERTIFICATES</a>
                <a href="#projects">PROJECTS</a>
                <a href="#contact">CONTACT</a>
            </div>
            <div className="burger-icon" onClick={ toggleMenu }>&#9776;</div>
            <div className="mobile-links">
                <a href="#home" onClick={ closeMenu }>HOME</a>
                <a href="#technologies" onClick={ closeMenu }>TECHNOLOGIES</a>
                <a href="#educacion" onClick={ closeMenu }>EDUCATION</a>
                <a href="#certificates" onClick={ closeMenu }>CERTIFICATES</a>
                <a href="#projects" onClick={ closeMenu }>PROJECTS</a>
                <a href="#contact" onClick={ closeMenu }>CONTACT</a>
            </div>
        </nav>
    );
}

export default Navbar;